import React, { useState, useEffect } from 'react';
import DocumentsList from './DocumentsList';
import { useMiddleman } from '@hubins/middleman';


const PrivateDocuments = ({ tags, excludeTag = 'internalDocument', table, title, compact, className, children, portfolio, portfolioUuid, profileUuid }) => {
  const middleman = useMiddleman();

  const [documents, setDocuments] = useState<any[]>([]);

  const getDocumentsInfo = (response) => {
    let newDocuments = response.data[0].documents;
    if (tags) {
      newDocuments = newDocuments.filter(
        doc => doc.tags.includes(tags)
      );
    }
    if (excludeTag) {
      newDocuments = newDocuments.filter(
        doc => !doc.tagsAsSet.includes(excludeTag)
      );
    }
    return newDocuments;
  };

  const fetchDocuments = async () => {
    setDocuments([]);
    const uri = (portfolio ? '/v1/fa/portfolio/documents/' : '/v1/fa/user/documents/') + portfolioUuid + (profileUuid ? `/${profileUuid}` : '');
    const docRes = await middleman.promiseGet(uri).then((res) => {
      return getDocumentsInfo(res);
    });
    setDocuments(docRes);
  };

  useEffect(() => {
    fetchDocuments();
  }, [portfolioUuid]);

  return (
    <DocumentsList
      documents={documents}
      auth={true}
      table={table}
      title={title}
      compact={compact}
      className={className}
    >
      {children}
    </DocumentsList>
  );
};

export default PrivateDocuments;
